var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import styled from 'styled-components';
import classnames from 'classnames';
import { AXSBlock } from '@axs/axsui-axsblock';
var Div = styled(AXSBlock)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  align-self: ", ";\n  align-items: ", ";\n  display: ", ";\n  flex-basis: ", ";\n  flex-grow: ", ";\n  flex-shrink: ", ";\n  order: ", ";\n  min-width: auto;\n"], ["\n  align-self: ", ";\n  align-items: ", ";\n  display: ", ";\n  flex-basis: ", ";\n  flex-grow: ", ";\n  flex-shrink: ", ";\n  order: ", ";\n  min-width: auto;\n"])), function (_a) {
    var alignSelf = _a.alignSelf;
    return alignSelf;
}, function (_a) {
    var alignItems = _a.alignItems;
    return alignItems;
}, function (_a) {
    var flex = _a.flex;
    return (flex ? 'flex' : 'block');
}, function (_a) {
    var flexBasis = _a.flexBasis;
    return flexBasis;
}, function (_a) {
    var flexGrow = _a.flexGrow;
    return flexGrow;
}, function (_a) {
    var flexShrink = _a.flexShrink;
    return flexShrink;
}, function (_a) {
    var order = _a.order;
    return order;
});
export var AXSFlexItem = function (props) {
    return (React.createElement(Div, __assign({}, props, { backgroundColor: props.backgroundColor, className: classnames(['c-axs-flex-item', props.className]) })));
};
var templateObject_1;
